<template>
<header>
<span>xue2sheng</span>
</header>
<main>
<img alt="Shannon icecream" src="./assets/hero-bg.webp" width="250" />
<ul>
<li>
<a href="https://andressevillano.com" target="_blank" rel="noopener"
>Professional Webpage</a
>
</li>
</ul>
<br />
<ul>
<li>
<a href="https://squattinggopniks.com" target="_blank" rel="noopener"
>Team</a
>
</li>
<li>
<a href="https://github.com/xue2sheng" target="_blank" rel="noopener"
>GitHub</a
>
</li>
<li>
<a href="https://bitbucket.org/xue2sheng" target="_blank" rel="noopener"
>BitBucket</a
>
</li>
</ul>
<br />
<ul>
<li>
<a href="https://xue2sheng.com/ebooks/" target="_blank" rel="noopener"
>Private</a
>
</li>
<li>
<a href="https://xue2sheng.com/english/" target="_blank" rel="noopener"
>English</a
>
/
<a
href="https://xue2sheng.wixsite.com/english"
target="_blank"
rel="noopener"
>Homework</a
>
</li>
<li>
<a href="https://xue2sheng.com/draft/" target="_blank" rel="noopener"
>Draft</a
>
</li>
</ul>
<br />
<ul>
<li>
<a
href="https://xue2sheng.com/desktop/index.html"
target="_blank"
rel="noopener"
>Desktop</a
>
/
<a href="https://xue2sheng.dynv6.net" target="_blank" rel="noopener"
>KVM</a
>
</li>
<li>
<a href="https://xue2sheng.com/dart/" target="_blank" rel="noopener"
>Dart</a
>
</li>
<li>
<a href="https://xue2sheng.com/ipa/" target="_blank" rel="noopener"
>Websocket</a
>
</li>
</ul>
</main>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
export default class App extends Vue {}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
color: #2c3e50;
       margin-top: 0px;
}

body {
margin: 0;
}

main h1,
     h2 {
         font-weight: normal;
     }

main ul {
    list-style-type: none;
padding: 0;
}

main {
    text-align: center;
    margin-top: 40px;
}

main ul {
    list-style-type: none;
padding: 0;
}

main li {
display: inline-block;
margin: 0 10px;
}

main a {
color: #35495e;
}

header {
margin: 0;
height: 56px;
padding: 0 16px 0 24px;
         background-color: #35495e;
color: #ffffff;
}

header span {
display: block;
position: relative;
          font-size: 20px;
          line-height: 1;
          letter-spacing: 0.02em;
          font-weight: 400;
          box-sizing: border-box;
          padding-top: 16px;
          text-align: center;
}
</style>
